import React from 'react';
import { Column } from 'react-foundation';

/**
 * Popups regarding confirmation screens -> leaving page confirmation & publishing confirmation
 * @param handleSubmit what happens when submit is pressed
 * @param handleClose what happens when cancelled or clicked on background
 * @param leftButtonText text for the left button
 * @param rightButtonText text for the right button
 * @param headerText text for the header message
 */
const opportunityConfirmationPopup = ({
	handleSubmit,
	handleClose,
	leftButtonText,
	rightButtonText,
	headerText,
}) => {
	const handleSubmitThenClose = () => {
		handleSubmit();
		handleClose();
	};

	return (
		<div
			className="opportunity-confirmation-popup"
			id="opportunity-confirmation-popup"
		>
			<div className="background-filter" onClick={handleClose} />
			<div className="popup-outer">
				<i
					id="close-button"
					className="fas fa-times float-right"
					onClick={handleClose}
				/>
				<div
					className="popup-inner"
					id="publish-confirmation-popup-inner"
				>
					<h6 className="publish-confirmation-h6">{headerText}</h6>
					<Column medium={6} small={12}>
						<div
							className="secondary-button hollow float-left"
							onClick={handleClose}
						>
							<p>{leftButtonText}</p>
						</div>
					</Column>
					<Column medium={6} small={12}>
						<div
							className="primary-button float-right mobile-button-margin-resizing"
							onClick={handleSubmitThenClose}
						>
							<p>{rightButtonText}</p>
						</div>
					</Column>
				</div>
			</div>
		</div>
	);
};

export default opportunityConfirmationPopup;
